export default function buildMakeFireFlowTest({ validate, validators, makeTorqueLog }) {
  return function makeFireFlowTest({
    id,
    companyId,
    startDate,
    endDate,
    totalGallonsUsed,
    maxGPM,
    elapsedSeconds,
    createdBy,
    createdDate = new Date(),
    modifiedBy,
    modifiedDate = new Date(),
    deletedBy,
    deletedDate,
  }) {
    const schema = {
      id: {
        prettyName: 'ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      companyId: {
        prettyName: 'Company ID',
        validators: [validators.isString(), validators.exactLength(36)],
      },
      startDate: {
        prettyName: 'Start Date',
        validators: [validators.notNull(), validators.isDate()],
      },
      endDate: {
        prettyName: 'End Date',
        validators: [validators.notNull(), validators.isDate()],
      },
      totalGallonsUsed: {
        prettyName: 'Total Gallons Used',
        validators: [validators.isNumber()],
      },
      maxGPM: {
        prettyName: 'Max GPM',
        validators: [validators.isNumber()],
      },
      elapsedSeconds: {
        prettyName: 'Elapsed Seconds',
        validators: [validators.isInteger()],
      },
    };

    return Object.freeze({
      get id() { return id },
      get companyId() { return companyId },
      get startDate() { return startDate ? new Date(startDate) : null  },
      get endDate() { return endDate ? new Date(endDate) : null  },
      get totalGallonsUsed() { return totalGallonsUsed },
      get maxGPM() { return maxGPM },
      get elapsedSeconds() { return elapsedSeconds },
      get createdBy() { return createdBy },
      get createdDate() { return createdDate ? new Date(createdDate) : null },
      get modifiedBy() { return modifiedBy },
      get modifiedDate() { return modifiedDate ? new Date(modifiedDate) : null },
      get deletedBy() { return deletedBy },
      get deletedDate() { return deletedDate ? new Date(deletedDate) : null },
      validate() {
        const errors = validate(this, schema);
        if (errors.length > 0) {
          const message = errors.map(e => e.name + ': ' + e.message).join('\n');
          const validationError = new Error(message);
          validationError.name = 'ValidationError';
          throw validationError;
        }
      }
    });
  }
}